import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class UserDoesNotHaveRequiredPermissionErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [
                {
                    'code': 'user_does_not_have_required_permission_error',
                    'text': 'User does not have required permission exception'
                }
            ]
        }
    }

    static errorCodes() {
        return ['user_does_not_have_required_permission_error'];
    }
}